import { SVGProps } from "react";

type Props = SVGProps<SVGSVGElement> & {
  color?: string;
  size?: number;
};

const SvgTickIcon = ({ color, size = 40, ...props }: Props) => {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      id="svg-wrapper"
      transform={`scale(${size / 40})`}
      {...props}
    >
      <path
        d="M28.025 9.825 16.608 25.617l-5.391-4.05a.515.515 0 0 0-.717.1l-1.858 2.466a.515.515 0 0 0 .1.717l8.325 6.258a.51.51 0 0 0 .725-.108l13.566-18.767a.51.51 0 0 0-.116-.716l-2.5-1.809a.51.51 0 0 0-.717.117Z"
        fill={color || "#595959"}
      />
    </svg>
  );
};

export default SvgTickIcon;
